export const DEFAULT_LANG = 'nl';

const LANG_CACHE_KEY = 'settings.lang';

export async function setSavedLanguage(lang: string) {
  localStorage.setItem(LANG_CACHE_KEY, lang);
}

export function getSavedLanguage() {
  return localStorage.getItem(LANG_CACHE_KEY) || DEFAULT_LANG;
}
